import { VibrationsChart } from "./charts/VibrationsChart";
import { Information } from "./informations";

export class VibrationRecord {
    vibrationRecord: VibrationsChart;
    information: Information;
}